import {Person} from 'generated/JavaTOmodifications';
import {getStringRepresentation} from 'model/Person';
import {PersonSlctOption} from 'module/Person/hook/usePersonSlctOptions'

export function mapPersonToSelectItem(person: Person, templateId: number | string): Pick<PersonSlctOption, 'value' | 'label' | 'model'> {
	return {
		value: person && person.persNr,
		label: getStringRepresentation(person, templateId),
		model: person,
	}
}